import textServices from 'services/text-services'
import useRouter from 'hooks/use-router'
import { dlTrackEvent } from 'components/dataLayer/dataLayer'
import { PIT_STOPS, getPitStopRoute } from '../constants'
import { getPitStopViewStatus } from '../pit-stop-status'
import F1Picture from './F1Picture'

interface PitStopModulesProps {
  /** Injectable clock for tests/QA; production uses the real date */
  now?: Date
}

// Weekly module cards for logged users (Figma 5409:3581 / 5410:4448):
// active = blue art background + "Participar", upcoming = dimmed with the
// unlock date, closed = dimmed after the final stage starts (the
// "already participating may finish" exception needs backend data and is
// deferred).
const PitStopModules = ({ now }: PitStopModulesProps) => {
  const { push } = useRouter()

  return (
    <ul className="pitstops__modules">
      {PIT_STOPS.map((pitStop) => {
        const route = getPitStopRoute(pitStop.key)
        const status = getPitStopViewStatus(pitStop, route, now)
        const isActive = status === 'active'

        const ctaLabel = isActive
          ? (textServices.findByText('pitstops/modules/cta', 'Participar') as string)
          : status === 'upcoming'
            ? `${textServices.findByText('pitstops/modules/locked', 'Se habilita el')} ${pitStop.unlockLabel}`
            : (textServices.findByText('pitstops/modules/closed', 'Participación cerrada') as string)

        const handleClick = () => {
          if (!isActive || !route) return
          dlTrackEvent('user_interaction', {
            action: 'click',
            element: `pit stop ${pitStop.order} :: participar`,
            section: 'pitstops'
          })
          push(route)
        }

        return (
          <li
            key={pitStop.key}
            className={`pitstops__module pitstops__module--${isActive ? 'active' : 'disabled'}`}
          >
            {isActive && (
              <F1Picture
                name="pit_stops-background"
                pictureClassName="pitstops__module-bg"
                className="pitstops__module-bg-media"
              />
            )}
            <div className="pitstops__module-content">
              <div className="pitstops__module-heading">
                <h3 className="pitstops__module-title">
                  {textServices.findByText('pitstops/modules/rowLabel', 'PIT STOP')} {pitStop.order}
                </h3>
                <p className="pitstops__module-name">{pitStop.name}</p>
              </div>
              <p className="pitstops__module-text">{pitStop.description}</p>
            </div>
            <button
              type="button"
              className="home-v3__button pitstops__module-cta"
              disabled={!isActive}
              onClick={handleClick}
            >
              {ctaLabel}
            </button>
          </li>
        )
      })}
    </ul>
  )
}

export default PitStopModules
